<template>
    <div class="c-payment">
        <b-row class="mt-3">
            <b-col>
                <InputCurrency
                        :readOnly="forceTotal"
                        :label="Core.Definition.getDefinition('Montant')"
                        v-model="dataPayment.total"></InputCurrency>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <InputSelect
                        :options="methodOptions"
                        :label="Core.Definition.getDefinition('Méthode')"
                        v-model="dataPayment.method"></InputSelect>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <InputCC
                        v-if="Core.Value.decode(dataPayment.method, 'select') === Core.Payment.methodCC"
                        ref="CC"
                        :form="form"
                        :fieldRefs="fieldRefs"
                        :onTokenizationSuccess="onTokenizationSuccess"
                        :onTokenizationError="onTokenizationError"
                        v-model="dataPayment.CC"></InputCC>
                <CCDefault ref="ccDefault"
                           v-if="Core.Value.decode(dataPayment.method, 'select') === Core.Payment.methodSavedCC && Core.Validation.isId(userId)"
                           v-model="dataCCDefault"
                           :displaySelectSaved="Core.Validation.isId(userId)"
                           :entityId="userId" entityType="user">
                </CCDefault>
                <InputText
                        v-if="Core.Value.decode(dataPayment.method, 'select') !== Core.Payment.methodCC && Core.Value.decode(dataPayment.method, 'select') !== Core.Payment.methodSavedCC"
                        :label="Core.Definition.getDefinition('# référence')"
                        v-model="dataPayment.referenceNumber"></InputText>
            </b-col>
        </b-row>
        <hr/>
        <b-row>
            <b-col class="text-right">
                <b-button @click="onProcessPaymentClick" class="btn btn-success">{{Core.Definition.getDefinition('Effectuer le paiement')}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import Request from './Request'
    import List from './List'
    import Alert from './Alert'
    import InputSelect from './InputSelect'
    import InputDate from './InputDate'
    import InputText from './InputText'
    import InputCurrency from './InputCurrency'
    import InputCC from './InputCC'
    import InputCheckbox from './InputCheckbox'
    import CCDefault from './CCDefault'
    export default {
        name: 'Payment',
        components: {
            InputCurrency,
            List,
            InputSelect,
            InputText,
            InputDate,
            InputCC,
            Alert,
            Request,
            InputCheckbox,
            CCDefault
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        date: '',
                        method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                        status: null,
                        referenceNumber: '',
                        subTotal: 0,
                        total: 0,
                        totalTaxes: 0,
                        token : '',
                        id: ''
                    }
                }
            },
            forceTotal: {
                type: Boolean,
                default: true
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            userId: {
                type: Number | String,
                default: function () {
                    return ''
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataPayment = val
                },
                deep: true
            },
            dataPayment: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataPayment = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataId: '',
                dataCCDefault: {
                    id: ''
                },
                dataPayment: {
                    date: '',
                    method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                    status: null,
                    referenceNumber: '',
                    subTotal: 0,
                    total: 0,
                    totalTaxes: 0,
                    CC: {
                        holderName: '',
                        number: '',
                        expMonth: '',
                        expYear: '',
                        CVD: '',
                        token: ''
                    },
                    id: ''
                },
                dataTotal: 0
            }
        },
        computed: {
            id: {
                get() {
                    return this.dataId
                },
                set(val) {
                    this.dataId = val
                }
            },
            methodOptions() {
                let methodOptions = Core.Payment.methodOptions([Core.Payment.methodCC, Core.Payment.methodCash, Core.Payment.methodTerminal])
                if (Core.Validation.isId(this.userId)) {
                    methodOptions = Core.Payment.methodOptions([Core.Payment.methodCC, Core.Payment.methodCash, Core.Payment.methodTerminal, Core.Payment.methodSavedCC])
                }
                return methodOptions
            }
        },
        methods: {
            onResetClick() {
                this.dataPayment =  {
                    date: '',
                    method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                    status: null,
                    referenceNumber: '',
                    subTotal: 0,
                    total: 0,
                    totalTaxes: 0,
                    CC: {
                        holderName: '',
                        number: '',
                        expMonth: '',
                        expYear: '',
                        CVD: '',
                        token: ''
                    },
                    id: ''
                }
                this.$refs.CC.reset()
            },
            onProcessPaymentClick() {
                if (Core.Value.decode(this.dataPayment.method, 'select') === Core.Payment.methodSavedCC) {
                    if (this.dataCCDefault.cardId !== '' && this.dataCCDefault.profileId !== '') {
                        let payment = {
                            cardId: this.dataCCDefault.cardId,
                            profileId: this.dataCCDefault.profileId,
                            subTotal: this.dataPayment.subTotal,
                            total: this.dataPayment.total,
                            totalTaxes: this.dataPayment.totalTaxes,
                            date: this.dataPayment.date,
                            method: Core.Payment.methodSavedCC,
                            id: this.dataPayment.id
                        }
                        this.$emit('onTokenizationSuccess', payment)
                    }
                } else {
                    if (Core.Value.decode(this.dataPayment.method, 'select') === Core.Payment.methodCC) {
                        this.$refs.CC.getToken()
                    } else {
                        this.dataPayment.date = Vue.moment().format('YYYY-MM-DD')
                        this.dataPayment.status = Core.Payment.statusCompleted
                        this.dataPayment.method = Core.Select.value(this.dataPayment.method)
                        this.$emit('onPaymentCompleted', this.dataPayment)
                    }
                }

            },
            onTokenizationSuccess(token, form) {
                let payment = {
                    token: token,
                    id: this.dataPayment.id,
                    subTotal: this.dataPayment.subTotal,
                    total: this.dataPayment.total,
                    totalTaxes: this.dataPayment.totalTaxes,
                    date: this.dataPayment.date,
                    method: Core.Payment.methodCC,
                    CC: {
                        last4: this.dataPayment.CC.number.slice(-4),
                        expMonth: this.dataPayment.CC.expMonth,
                        expYear: this.dataPayment.CC.expYear
                    }
                }
                this.$emit('onTokenizationSuccess', payment)
            },
            onTokenizationError(form) {
                this.$emit('onTokenizationError')
            }
        }
    }
</script>
